import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { history } from '../../history';
import { AuthAction } from '../../actions/AuthAction';
import { AppHeader } from '../../components/common';
import UserAccount from './UserAccount';
import UserSettings from './UserSettings';
import AdminSettingShortcuts from './AdminSettingShortcuts';
import MyWorkSchedule from './MyWorkSchedule';
import { Translate as t } from '../../config/Translate';
import { ROUTES } from '../../config/routes';
import { ROLE_EXTERNAL_DEALER } from '../../config/appConstants';
import { getLicenseRole } from '../../lib/licenseHelper';
import { isAdminPathname } from '../../lib/isAdminPathname';

export const MyInfo = ({ user }) => {

	// const [t, i18n] = useTranslation();
	const { view } = useParams();
	const [maintab, setMainTab] = useState(view || "info");
	const [editable, setEditable] = useState(false);
	// 기술자·관리자 두 레이아웃에서 같은 화면을 쓴다. 관리자 레이아웃은 주소 /Admin/* 로 정해진다.
	const isAdmin = isAdminPathname(window.location.pathname);
	const isExternalDealer = getLicenseRole(user) === ROLE_EXTERNAL_DEALER;
	// 외부 딜러는 근무일정(기술자 전용) 탭을 쓰지 않는다 — 주소로 들어와도 기본 탭으로.
	const requestedTab = view || "info";
	const blockedTab = isExternalDealer && requestedTab === "workschedule";
	if (blockedTab) {
		console.warn('[guard] my-info tab blocked', {
			handler: 'MyInfo.render',
			callerCompanyId: user?.companyId,
			callerRole: ROLE_EXTERNAL_DEALER,
			targetTab: requestedTab,
			reason: 'workschedule tab is not available to external dealer',
		});
	}
	const activeTab = blockedTab ? "info" : maintab;

	useEffect(() => {
		setMainTab(view || "info")
	}, [view])

	const mainTabList = [
		{ code: "info", title: t('user.label.myAccount'), icon: "info" },
		{ code: "setting", title: t('common.label.settings'), icon: "info" },
		{ code: "workschedule", title: t('user.workSchedule.title'), icon: "time" },
	].filter(x => !(isExternalDealer && x.code === "workschedule"))

	const goUrl = (code) => {
		history.push((isAdmin ? ROUTES.ADMIN_MY_INFO : "/MyInfo") + "/" + code);
	}

	return (
		<>
			{!isAdmin && <div className="appHeader full-color">
				<AppHeader title={user && user.adminid} />
			</div>}
			<div id="appCapsule">
				<div className="section">
					<ul className="nav nav-tabs style2 mt-1 mb-1">
						{mainTabList.map(x =>
							<li className="nav-item">
								<button key={x.code}
									className={activeTab == x.code ? "nav-link active" : "nav-link"} onClick={() => { goUrl(x.code); }}>
									{x.title}
								</button>
							</li>
						)}
					</ul>
				</div>
				{activeTab == "info" && <UserAccount />}
				{activeTab == "setting" && <UserSettings />}
				{(isAdmin && activeTab == "setting") && <AdminSettingShortcuts user={user} isExternalDealer={isExternalDealer} />}
				{activeTab == "workschedule" && <MyWorkSchedule />}
			</div>
		</>
	)
}

const mapState = state => {
	const user = AuthAction.getUserInfo(state);
	return { user }
}

export default connect(mapState)(MyInfo);